<template>
  <!-- <div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div> -->
  <router-view />
</template>

<style>
@media screen {
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    /* max-width: 9.6125in; */
    max-width: 9.75in;
    /* padding: 0.06125in 0.25in 0.125in 0.325in; */
    /* 0.325in 0.46875in 0.325in */
    padding: 0.06125in 0.25in 0.125in 0.25in;
    /* outline: solid black 1px; */
    height: 10.25in;
    /* background-color: #3b404e; */
    /* height: 100vh; */
    /* display: flex; */
    /* justify-content: center; */
    /* align-items: center; */
  }
}
@media print {
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    /* max-width: 9.6125in; */
    max-width: 8.5in;
    /* padding: 0.06125in 0.25in 0.125in 0.325in; */
    /* 0.325in 0.46875in 0.325in */
    padding: 0.06125in 5mm 0.125in 5mm;
    /* outline: solid black 0.5px; */
    height: 10.25in;
    margin-right: 3px;
    /* background-color: #3b404e; */
    /* height: 100vh; */
    /* display: flex; */
    /* justify-content: center; */
    /* align-items: center; */
    /* transform: scale(1.01); */
  }
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
